/* global axios */
import ApiClient from './ApiClient';

class TemplateSchedulesAPI extends ApiClient {
  constructor() {
    super('template_schedules', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  stop(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  kill(id) {
    return axios.post(`${this.url}/${id}/kill`);
  }
}

export default new TemplateSchedulesAPI();
